import React, { useEffect, useState } from "react"
import styled from "styled-components"
import Button from "../Button"
import Text from "../Text"
import { hasConsented, setConsent } from "@/common/utils/cookieConsent"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"

const CookieBannerWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background-color: ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.white};
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid #ffc211;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% - 40px);
  max-width: 500px;

  @media (min-width: 768px) {
    padding: 16px 24px;
    flex-direction: row;
    align-items: center;
    max-width: 900px;
  }
`

const Content = styled.div`
  flex: 1;
  margin-bottom: 16px;
  width: 100%;

  @media (min-width: 768px) {
    margin-bottom: 0;
    margin-right: 16px;
    width: auto;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;

  @media (min-width: 480px) {
    gap: 12px;
    flex-wrap: nowrap;
  }

  @media (min-width: 768px) {
    width: auto;
  }
`

const StyledButton = styled(Button)`
  flex: 1;
  min-width: 130px;

  @media (min-width: 480px) {
    flex: initial;
  }
`

const CookieConsent = () => {
  const [visible, setVisible] = useState(false)
  const router = useRouter()
  const { t } = useTranslation("cookie")

  useEffect(() => {
    // Check if user has already consented
    if (!hasConsented()) {
      // Show banner after a small delay
      const timer = setTimeout(() => {
        setVisible(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const acceptAll = () => {
    setConsent("all")
    setVisible(false)
  }

  const acceptNecessary = () => {
    setConsent("necessary")
    setVisible(false)
  }

  if (!visible) return null

  return (
    <CookieBannerWrapper>
      <Content>
        <Text content={t("consent.message")} />
        <Text>
          <a
            href="https://www.notion.so/kryptogo/Cookie-Policy-1d93499de8a2806892ffc105cc92cf71"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FFC211", textDecoration: "underline" }}
          >
            {t("consent.readMore")}
          </a>
        </Text>
      </Content>
      <ButtonGroup>
        <StyledButton
          title={t("consent.acceptNecessary")}
          onClick={acceptNecessary}
          colors="secondaryWithBg"
        />
        <StyledButton title={t("consent.acceptAll")} onClick={acceptAll} />
      </ButtonGroup>
    </CookieBannerWrapper>
  )
}

export default CookieConsent
